import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "m14.449 10.24-4.15-2.433a.831.831 0 0 1 .84-1.435l4.055 2.378a2.138 2.138 0 1 1-1.912 3.824l-1.988-.994a.833.833 0 0 1 .745-1.49l1.989.993a.471.471 0 1 0 .42-.842",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M7.159 6.667 5.303 14.71a.83.83 0 0 0 .278.827L7.8 17.386a.83.83 0 0 0 1.067 0l2.218-1.849a.83.83 0 0 0 .278-.827L9.507 6.667zm3.823-1.021A.83.83 0 0 0 10.17 5H6.496a.83.83 0 0 0-.812.646l-2.005 8.689a2.5 2.5 0 0 0 .835 2.483l2.219 1.848a2.5 2.5 0 0 0 3.2 0l2.219-1.848a2.5 2.5 0 0 0 .835-2.483z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M10.329 1.667H6.338a.83.83 0 0 0-.693.37l-.047.071A.83.83 0 0 0 5.576 3l.958 1.596c.15.251.422.405.715.405h2.169a.83.83 0 0 0 .714-.405L11.09 3a.83.83 0 0 0-.021-.89l-.047-.071a.83.83 0 0 0-.693-.371M6.338 0a2.5 2.5 0 0 0-2.08 1.113l-.047.07a2.5 2.5 0 0 0-.064 2.674l.958 1.596A2.5 2.5 0 0 0 7.25 6.667h2.169a2.5 2.5 0 0 0 2.144-1.214l.957-1.596a2.5 2.5 0 0 0-.063-2.673l-.047-.07A2.5 2.5 0 0 0 10.329 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }